export default __webpack_public_path__ + "106ecb098237b80b58a17eeeedcc2f57.png";